import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";
import i18next from "i18next";
import EAAutoCompleteInput from "components/inputs/EAAutoCompleteInput";
import { SearchFormInputBloc } from "components/lists-advanced-search/SearchFormInputBloc/SearchFormInputBloc";

export function ThirdpartiesSearchIndued({ induedOptions, filters }) {
  const { control, setValue } = useFormContext();

  const { fields } = useFieldArray({
    control,
    name: "indued",
  });

  useEffect(() => {
    if (filters?.indued) {
      filters.indued?.forEach((filter) => {
        const fieldIndex = fields.findIndex((field) => field.score === filter.score);
        setValue(`indued.${fieldIndex}.values`, filter.values || []);
      });
    }
  }, [fields, setValue, filters]);

  return (
    <>
      {induedOptions?.length > 0 &&
        fields.map((field, index) => {
          return (
            <Grid item xs={4} sm={3} md={2} key={field.id}>
              <SearchFormInputBloc label={i18next.t(`indued.scoresFilters.${field.score}`)} hasTooltip>
                <EAAutoCompleteInput
                  fieldName={`indued.${index}.values`}
                  options={induedOptions}
                  placeholder={i18next.t('thirdpartySearch.all')}
                  variant="outlined"
                  multiple
                  limitTags={1}
                />
              </SearchFormInputBloc>
            </Grid>
          );
        })}
    </>
  );
}
